export default {"src":"/_next/static/media/pergola.c88637ff.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};